'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pricingDependenciesSelector = exports.additionalSeatMonthlyCostSelector = exports.additionalContactsMonthlyCostSelector = exports.contactTierPriceMapSelector = exports.calculatedPriceSelector = exports.productDataSelector = undefined;

var _calculatedPriceAdapter = require('self-service-api/adapters/calculatedPriceAdapter');

var _calculatedPriceAdapter2 = _interopRequireDefault(_calculatedPriceAdapter);

var _MerchandiseSelectors = require('pricing-pages-unified-ui/selectors/MerchandiseSelectors');

var _AuthAdminSelectors = require('pricing-pages-unified-ui/selectors/AuthAdminSelectors');

var _CurrentSubscriptionsSelectors = require('pricing-pages-unified-ui/selectors/CurrentSubscriptionsSelectors');

var _contactTierPriceMapAdapter = require('self-service-api/adapters/contactTierPriceMapAdapter');

var _contactTierPriceMapAdapter2 = _interopRequireDefault(_contactTierPriceMapAdapter);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _reselect = require('reselect');

var _PromotionSelectors = require('./PromotionSelectors');

var _ProductOwnershipSelectors = require('./ProductOwnershipSelectors');

var _RequiredOnboardingSelectors = require('./RequiredOnboardingSelectors');

var _pricingUtils = require('../utils/pricingUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productDataSelector = exports.productDataSelector = function productDataSelector(state) {
  return {
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state),
    authState: (0, _AuthAdminSelectors.authStateSelector)(state)
  };
};

var calculatedPriceSelector = exports.calculatedPriceSelector = function calculatedPriceSelector(state, _ref) {
  var termId = _ref.termId,
      itemConfigurations = _ref.itemConfigurations;

  var merchandise = (0, _MerchandiseSelectors.merchandiseSelector)(state);
  var authState = (0, _AuthAdminSelectors.authStateSelector)(state);
  var currencyCode = (0, _CurrencySelectors.activeCurrencySelector)(state);
  var currentSubscriptions = (0, _CurrentSubscriptionsSelectors.currentSubscriptionsSelector)(state);
  var eligiblePromotions = (0, _PromotionSelectors.allPromotionsSelector)(state);

  if (!itemConfigurations.length || !merchandise || !authState) {
    return null;
  }

  var discountPercentage = (0, _pricingUtils.getDiscountPercentage)({
    eligiblePromotions: eligiblePromotions,
    merchandiseId: itemConfigurations[0].merchandiseId,
    termIdToUse: termId
  });

  var purchaseConfig = {
    termId: termId,
    currencyCode: currencyCode,
    itemConfigurations: itemConfigurations,
    discountPercentage: discountPercentage
  };

  return (0, _calculatedPriceAdapter2.default)({ products: merchandise, authState: authState }, purchaseConfig, currentSubscriptions);
};

var contactTierPriceMapSelector = exports.contactTierPriceMapSelector = function contactTierPriceMapSelector(state, merchandiseId, termId) {
  var merchandise = state.merchandise,
      currentSubscriptions = state.currentSubscriptions;

  var currencyCode = (0, _CurrencySelectors.activeCurrencySelector)(state);

  return (0, _contactTierPriceMapAdapter2.default)(merchandise, merchandiseId, currencyCode, termId, currentSubscriptions);
};

var additionalContactsMonthlyCostSelector = exports.additionalContactsMonthlyCostSelector = function additionalContactsMonthlyCostSelector(state, merchandiseId, termId) {
  var _ImmutableMerchandise = _ImmutableMerchandiseIdMap2.default[merchandiseId],
      additionalUnitMerchId = _ImmutableMerchandise.additionalUnitMerchId,
      includedAdditionalUnits = _ImmutableMerchandise.includedAdditionalUnits;

  var contactsMonthlyCost = calculatedPriceSelector(state, {
    termId: termId,
    itemConfigurations: [{
      merchandiseId: additionalUnitMerchId,
      quantity: includedAdditionalUnits + 1000
    }]
  }).monthly.calculatedPrice;

  return contactsMonthlyCost;
};

var additionalSeatMonthlyCostSelector = exports.additionalSeatMonthlyCostSelector = function additionalSeatMonthlyCostSelector(state, merchandiseId, termId) {
  var additionalUnitMerchId = _ImmutableMerchandiseIdMap2.default[merchandiseId].additionalUnitMerchId;

  var seatMonthlyCost = calculatedPriceSelector(state, {
    termId: termId,
    itemConfigurations: [{
      merchandiseId: additionalUnitMerchId,
      quantity: 1
    }]
  }).monthly.calculatedPrice;

  return seatMonthlyCost;
};

var pricingDependenciesSelector = exports.pricingDependenciesSelector = (0, _reselect.createSelector)(productDataSelector, _CurrencySelectors.activeCurrencySelector, _CurrentSubscriptionsSelectors.currentSubscriptionsSelector, _PromotionSelectors.allPromotionsSelector, _ProductOwnershipSelectors.parcelsSelector, _RequiredOnboardingSelectors.requiredOnboardingSelector, function (productData, currencyCode, currentSubscriptions, eligiblePromotions, parcels, requiredOnboarding) {
  return {
    productData: productData,
    currencyCode: currencyCode,
    currentSubscriptions: currentSubscriptions,
    eligiblePromotions: eligiblePromotions,
    parcels: parcels,
    requiredOnboarding: requiredOnboarding
  };
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/PricingSelectors.js
// module id = 35
// module chunks = 3 4